import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./slices/AppSlice";
import environmentReducer from "./slices/EnvironmentSlice";
import modelReducer from "./slices/ModelSlice";
import annotationsReducer from "./slices/AnnotationSlice";
import customizerReducer from "./slices/CustomizerSlice";
import exportReducer from "./slices/ExportSlice";
import userReducer from "./slices/UserSlice";

export const Store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
    model: modelReducer,
    environment: environmentReducer,
    annotations: annotationsReducer,
    customizer: customizerReducer,
    export: exportReducer,
  },
});
